import React, { useState } from 'react'
import LockClockIcon from '@mui/icons-material/LockClock';
import { Button, Form, Input } from 'semantic-ui-react'
import './RecoverPassword.scss'
import { recoverPassword } from '../../../redux/actions/auth';
import { toast } from 'react-toastify';

const RecoverPassword = () => {

    const [values, setValues] = useState({})

    const handleOnChange = e => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleOnSubmit = async e => {
        e.preventDefault();
        const response = await recoverPassword(values)
        if(response && response.status === true) {
            toast.success('Se ha enviado el email correctamente, siga los pasos indicados para crear una nueva contraseña', {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }

        if(response && response.error) {
            if(response.error.code === "auth/user-not-found")
            toast.error('Este usuario no existe en Shield', {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
    }

    return (
        <div className='recover_password'>
            <div className='contact_description'>
                <LockClockIcon style={{ fontSize: '50px', color: '#68bbe3' }} />
                <h2 style={{ color: '#68bbe3' }}>Introduce tu email y te enviaremos un correo de verificación para que cambies tu contraseña</h2>
            </div>
            <Form onSubmit={handleOnSubmit}>
                <Form.Field>
                    <label>Email</label>
                    <Input placeholder='Introduce tu email' name='email' onChange={handleOnChange} required />
                </Form.Field>

                <Button type='submit'>Enviar</Button>
            </Form>
        </div>
    )
}

export default RecoverPassword
